import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { CustomLegend } from "../charts/custom-legend";
import { ChartWrapper } from "../charts/chart-wrapper";
import { useChartTheme } from "../charts/hooks/useChartTheme";
import type { FC } from "react";
import { CustomTooltip } from "../charts/custom-tooltip";

interface DataPoint {
  readonly name: string;
  readonly value: number;
}

interface Props {
  readonly data: readonly DataPoint[];
}

/**
 * Renders a pie chart showing recurring vs. one-time revenue breakdown.
 */
export const LeadsRecurringOneTimeBreakdownChart: FC<Props> = ({ data }) => {
  const { chartProps } = useChartTheme();
  // Some color palette with only two slices
  const COLORS = ["#3B82F6", "#F59E0B"]; // blue, amber

  return (
    <ChartWrapper>
      <PieChart>
        <Pie
          data={[...data]}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          label
        >
          {[...data].map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          content={<CustomTooltip />}
          {...chartProps.tooltip}
          formatter={(value: number, name: string) => [
            `$${value.toLocaleString()}`,
            name,
          ]}
          cursor={false}
        />
        <Legend content={<CustomLegend />} {...chartProps.legend} />
      </PieChart>
    </ChartWrapper>
  );
};
